import React from 'react';
import { Box, Drawer, IconButton, Typography } from '@mui/material';
import X from '@mds/icons/X';

type MobileBottomDrawerProps = {
    open: boolean;
    onClose: () => void;
    title: string;
    children: React.ReactNode;
};

const MobileBottomDrawer: React.FC<MobileBottomDrawerProps> = ({
    open,
    onClose,
    title,
    children,
}) => {
    return (
        <Drawer
            anchor="bottom"
            open={open}
            onClose={onClose}
            slotProps={{
                paper: { sx: { width: '100%', maxHeight: '80dvh' } },
            }}
        >
            <Box
                sx={{
                    px: 2,
                    pt: 1,
                    pb: 2,
                    color: 'text.primary',
                    overflowY: 'auto',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 1,
                        mb: 1,
                    }}
                >
                    <Typography variant="h6">{title}</Typography>
                    <IconButton
                        aria-label="Close"
                        onClick={onClose}
                        sx={{ mr: -1 }}
                    >
                        <X fontSize="small" />
                    </IconButton>
                </Box>
                {children}
            </Box>
        </Drawer>
    );
};

export default MobileBottomDrawer;
